import * as React from 'react';
import { cn } from '@/shared/lib/utils';
import { themed } from './themed';

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

/** Themed native textarea. */
export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => (
    <textarea
      ref={ref}
      className={cn(
        themed.field.base,
        themed.field.border,
        themed.focusRing,
        'min-h-[80px] resize-y py-2',
        className,
      )}
      {...props}
    />
  ),
);
Textarea.displayName = 'Textarea';
